export class UserPermissionRequest {
  idUser!: number;
  listIdPermission: number[] = [];
}
